import Status from "components/Status";
import moment from "moment";
import { Link } from "react-router-dom";

const SupplierStockSubmitHistoryItem = ({ item, productsById }) => {
  let parsed;

  try {
    parsed = JSON.parse(item.data);
  } catch (error) {
    return (
      <div className="space-y-2 card">
        <div className="text-sm">
          <span className="font-semibold">#{item.id}</span>
          <span className="mx-2">·</span>
          <span>{moment(item.createdAt).format("YYYY-MM-DD HH:mm")}</span>
          <span className="mx-2">·</span>
          <span>
            {item.updatedBy?.email || item.updatedBy?.username || "-"}
          </span>
        </div>
        <div className="text-red-600 text-sm">
          Invalid submit payload. 提交数据格式异常。
        </div>
      </div>
    );
  }

  const products = Array.isArray(parsed?.products) ? parsed.products : [];

  return (
    <div className="space-y-2 card">
      <div>
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <div className="font-semibold">#{item.id}</div>
            {item.state ? <Status status={item.state} /> : null}
          </div>

          <Link
            to={`/inventory/submit-delivery?sourceId=${item.id}`}
            target="_blank"
          >
            重新提交
          </Link>
        </div>

        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm mt-2">
          <span>{moment(item.createdAt).format("YYYY-MM-DD HH:mm")}</span>
          <span>
            {item.updatedBy?.email || item.updatedBy?.username || "-"}
          </span>
        </div>
      </div>

      {products.length === 0 ? (
        <div className="text-sm opacity-70">No products. 没有产品明细。</div>
      ) : (
        <div className="-mx-2">
          <table className="text-sm whitespace-nowrap">
            <thead>
              <tr className="opacity-70">
                <th className="px-2 py-1 text-left w-full">Product / 产品</th>
                <th className="px-2 py-1 text-left">Date / 日期</th>
                <th className="px-2 py-1 text-right">QTY / 数量</th>
                <th className="px-2 py-1 text-left">Remark / 备注</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => {
                const productInfo = productsById?.[product.id];
                return (
                  <tr key={`${product.id}-${index}`} className="border-t">
                    <td className="px-2 py-1">
                      {productInfo ? (
                        <div>
                          <div className="font-semibold">
                            [{productInfo.number}] {productInfo.nameCn}
                          </div>
                          <div className="text-xs text-gray-700 whitespace-normal">
                            {productInfo.name}
                          </div>
                        </div>
                      ) : (
                        `Product #${product.id}`
                      )}
                    </td>
                    <td className="px-2 py-1">{product.readyDate}</td>
                    <td className="px-2 py-1 text-right">{product.qty}</td>
                    <td className="px-2 py-1 whitespace-normal">
                      {product.remark || "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SupplierStockSubmitHistoryItem;
